import React, { FC } from 'react'
import s from './Footer.module.sass'

import { ErrorBoundary } from '@shared/lib/components/ErrorBoundary'
import { ContainerFooter } from '@shared/ui/Layout/Containers/ContainerFooter'
import { useClientResponsive } from '@shared/lib/hooks/useClientResponsive'
import { FooterQRCode } from '@widgets/Common/Footer/components/FooterQRCode'
import { FooterTitle } from '@widgets/Common/Footer/components/FooterTitle'
import { FooterApps } from '@widgets/Common/Footer/components/FooterApps'
import { FooterSocials } from '@widgets/Common/Footer/components/FooterSocials'
import { FooterMeta } from '@widgets/Common/Footer/components/FooterMeta'
import { FooterFoundMistakeOpener } from '@widgets/Common/Footer/components/FooterFoundMistakeOpener'
import { FooterNavigation } from '@widgets/Common/Footer/components/FooterNavigation'
import { GigAssChatOpener } from '@widgets/Common/GigAssist/components/GigAssChatOpener'

const Footer: FC = () => {
  const { isDesktop, isTablet, isMobile } = useClientResponsive()

  return (
    <ErrorBoundary>
      <div className={s.wrapper}>
        <GigAssChatOpener isHideAnim={false} mode={'static-long'} className={s.gigass} />
        <ContainerFooter id={'page-footer'} classNameContainer={s.container} classNameContent={s.footer}>
          {/* ASIDE */}
          <div className={s.aside}>
            {isDesktop && <FooterQRCode />}
            {(isMobile || isTablet) && <FooterTitle />}
            {(isMobile || isTablet) && <FooterApps />}
            {isTablet && <FooterMeta />}
          </div>

          {/* MAIN */}
          <div className={s.main}>
            {isDesktop && (
              <div className={`${s['main-column']} ${s['main-column__1']}`}>
                <FooterTitle />
                <FooterApps />
                <FooterMeta />
              </div>
            )}

            <div className={`${s['main-column']} ${s['main-column__2']}`}>
              <FooterNavigation />
              <div className={s.meta}>
                <FooterSocials />
                {!isMobile && <FooterFoundMistakeOpener />}
                {isMobile && <FooterMeta />}
              </div>
            </div>
          </div>
        </ContainerFooter>
      </div>
    </ErrorBoundary>
  )
}

export default Footer
